import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { NavLink, useParams } from 'react-router-dom'
import { userMenu } from '../../utils/constants/navlinks-Menu'
import HeaderView from '../common/common-header/HeaderView'
import UsersService from '../../services/users/users.service'
import './navLinkMenu.scss'
import useAccess from '../../utils/hooks/useAccess'
import { GROUPS, MODULES } from '../../utils/constants/roles'

const UserNavLinkMenu = () => {
  const intl = useIntl()
  const { id } = useParams()

  const { canGet } = useAccess()

  const [user, setUser] = useState()

  useEffect(() => {
    getUser()
  }, [id])

  const getUser = async () => {
    const resp = await UsersService.getById(id)
    if (resp) {
      setUser(resp?.resp)
    }
  }

  return (
    <div className="header-menu">
      <HeaderView title={user?.name} showBackButton />
      <div className="navlink-menu">
        {userMenu.map(
          (navLink, i) =>
            canGet(navLink.module, navLink.group) && (
              <NavLink
                key={i}
                to={navLink?.path(id)}
                className="navlink-item"
                activeclassname="active"
              >
                {intl.formatMessage({ id: navLink?.id })}
              </NavLink>
            ),
        )}
      </div>
    </div>
  )
}

export default UserNavLinkMenu
